import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Panel from 'react-bootstrap/lib/Panel';

export default class ProjectCreativeUpsell extends Component {
  static propTypes = {
    project: PropTypes.object,
    credits: PropTypes.array,
    suggestedRoles: PropTypes.array,
  };

  constructor() {
    super();

    this.state = {
      talentRoles: [],
    };
  }

  componentDidMount() {
    if (this.props.project && this.props.credits) {
      this.initRolesSkills();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.credits !== prevProps.credits ||
        this.props.project !== prevProps.project) &&
      this.props.project &&
      this.props.credits
    ) {
      this.initRolesSkills();
    }
  }

  initRolesSkills() {
    let talentRoles = this.props.credits.map((credit) => {
      const roleElement = [];
      credit.roles.map((tag) => {
        this.props.suggestedRoles.forEach((role) => {
          if (
            typeof role !== 'undefined' &&
            (role.slug.replace('-', '') === tag ||
              role.slug_plural.replace('-', '') === tag ||
              role.name === tag ||
              role.name_plural === tag)
          ) {
            roleElement.push(
              <div className="text-center mb--">
                <Link
                  to={'/jobs/' + role.slug_plural}
                  style={{ color: 'white' }}
                >
                  {role.name} Jobs
                </Link>
              </div>
            );
          }
        });
      });

      return roleElement;
    });

    talentRoles = talentRoles.filter((role) => role);

    if (talentRoles.length <= 0) {
      let randomRoles = [
        'graphicdesigner',
        'illustrator',
        'imageeditor',
        'uxdesigner',
      ];
      if (this.props.project.mediaType === 'audio') {
        randomRoles = ['vocalist', 'dj', 'musicproducer', 'musician'];
      } else if (this.props.project.mediaType === 'video') {
        randomRoles = [
          'filmproducer',
          'videoeditor',
          'cameraoperator',
          'postproduction',
        ];
      }

      randomRoles = [
        randomRoles[Math.floor(Math.random() * randomRoles.length)],
      ];

      talentRoles = randomRoles.map((tag) => {
        return this.props.suggestedRoles.map((role) => {
          if (
            typeof role !== 'undefined' &&
            (role.slug.replace('-', '') === tag ||
              role.slug_plural.replace('-', '') === tag)
          ) {
            return (
              <div className="text-center mb--">
                <Link
                  to={'/jobs/' + role.slug_plural}
                  style={{ color: 'white' }}
                >
                  {role.name} Jobs
                </Link>
              </div>
            );
          }
        });
      });
    }

    if (talentRoles !== this.state.talentRoles) {
      this.setState({ talentRoles });
    }
  }

  render() {
    if (this.state.talentRoles.length <= 0) {
      return <noscript />;
    }

    return (
      <Panel
        bsStyle="primary"
        style={{ backgroundColor: '#40a0f5', padding: '10px' }}
      >
        <div className="fs-16 text-center lato-bold mb-">
          <Link to="/jobs" style={{ color: 'white' }}>
            Find jobs
          </Link>
        </div>
        {this.state.talentRoles}
      </Panel>
    );
  }
}
